<script setup lang="ts">
// types
import type { StrapiMenuLink } from '@ts-strapi/interfaces'
// hooks
import { useOpenMenuLink } from '@composables/tools/open-menu-link.hook'
// components
import { BtnPrimary } from '@UI/Buttons/BtnPrimary'
import { BtnSecondary } from '@UI/Buttons/BtnSecondary'

defineOptions({
  name: 'HeaderActions',
})

defineProps<{
  primary: StrapiMenuLink
  secondary: StrapiMenuLink
}>()

const openLink = useOpenMenuLink()
</script>

<template>
  <div class="header-actions">
    <BtnPrimary
      v-if="primary"
      @click="openLink(primary)"
    >
      {{ primary.label }}
    </BtnPrimary>
    <BtnSecondary
      v-if="secondary"
      @click="openLink(secondary)"
    >
      {{ secondary.label }}
    </BtnSecondary>
  </div>
</template>

<style scoped lang="scss" src="@scss/components/Widgets/Headers/HeaderActions.scss" />
